export const electronicsLevelTwo = [
    {
        "parentCategoryId": "electronics",
        "categoryId": "mobiles",
        "level": 2,
        "name": "Mobiles",
        "parentCategoryName": "Electronics"
      },
      {
        "parentCategoryId": "electronics",
        "categoryId": "mobile_accessories",
        "level": 2,
        "name": "Mobile Accessories",
        "parentCategoryName": "Electronics"
      },
      {
        "parentCategoryId": "electronics",
        "categoryId": "smart_wearable_tech",
        "level": 2,
        "name": "Smart Wearable Tech",
        "parentCategoryName": "Electronics"
      },
      // {
      //   "parentCategoryId": "electronics",
      //   "categoryId": "health_care_appliances",
      //   "level": 2,
      //   "name": "Health Care Appliances",
      //   "parentCategoryName": "Electronics"
      // },
      {
        "parentCategoryId": "electronics",
        "categoryId": "laptops",
        "level": 2,
        "name": "Laptops",
        "parentCategoryName": "Electronics"
      },
      {
        "parentCategoryId": "electronics",
        "categoryId": "tablets",
        "level": 2,
        "name": "Tablets",
        "parentCategoryName": "Electronics"
      },
      // {
      //   "parentCategoryId": "electronics",
      //   "categoryId": "televisions",
      //   "level": 2,
      //   "name": "Televisions",
      //   "parentCategoryName": "Electronics"
      // },
      {
        "parentCategoryId": "electronics",
        "categoryId": "speakers",
        "level": 2,
        "name": "Speakers",
        "parentCategoryName": "Electronics"
      },
      // {
      //   "parentCategoryId": "electronics",
      //   "categoryId": "smart_home_automation",
      //   "level": 2,
      //   "name": "Smart Home Automation",
      //   "parentCategoryName": "Electronics"
      // },
      {
        "parentCategoryId": "electronics",
        "categoryId": "camera",
        "level": 2,
        "name": "Camera",
        "parentCategoryName": "Electronics"
      },
      // {
      //   "parentCategoryId": "electronics",
      //   "categoryId": "network_components",
      //   "level": 2,
      //   "name": "Network Components",
      //   "parentCategoryName": "Electronics"
      // },
      // {
      //   "parentCategoryId": "electronics",
      //   "categoryId": "featured",
      //   "level": 2,
      //   "name": "Featured",
      //   "parentCategoryName": "Electronics"
      // }
]